import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import pt from "./locales/pt.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import ja from "./locales/ja.json";

export const SUPPORTED_LANGUAGES = [
  { code: "pt", label: "Português", flag: "🇧🇷", nativeLabel: "Português" },
  { code: "en", label: "English", flag: "🇺🇸", nativeLabel: "English" },
  { code: "es", label: "Español", flag: "🇪🇸", nativeLabel: "Español" },
  { code: "fr", label: "Français", flag: "🇫🇷", nativeLabel: "Français" },
  { code: "de", label: "Deutsch", flag: "🇩🇪", nativeLabel: "Deutsch" },
  { code: "ja", label: "日本語", flag: "🇯🇵", nativeLabel: "日本語" },
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]["code"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      ja: { translation: ja },
    },
    fallbackLng: "pt",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "guia-essencial-language",
      caches: ["localStorage"],
    },
  });

export default i18n;
